import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { BehaviorSubject, Subscription } from 'rxjs';
import { AngularFireMessaging } from '@angular/fire/messaging';

import { environment } from "../environments/environment";
import { GlobalCfgService } from "./globalcfg.service";

@Injectable()
export class NotificationsService {

	currentMessage = new BehaviorSubject(null);
	fcmToken: string;
	deviceInfo: any;
	name: string;
	devicePlatform: string;
	loggedIn: boolean;
	currentYear: number;
	notificationSubcription: Subscription;

	constructor(
		private http: HttpClient,
		private globalCfgService: GlobalCfgService,
		private angularFireMessaging: AngularFireMessaging
	) {
		this.notificationSubcription = this.angularFireMessaging.messages.subscribe((payload) => {
			this.showCustomNotification(payload)
		});
	}

	public getSegmentsList() {
		return this.http.get(
			environment.apiurl +
			"/Segments/getSegmentList?" +
			"&access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public getSegmentsForNotifications() {
		return this.http.get(
			environment.apiurl +
			"/Segments?filter=" +
			JSON.stringify({ where: { isActive: true } }) +
			"&access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public getNotifications() {
		return this.http.get(
			environment.apiurl +
			"/Notifications/getNotificationList?" +
			"&access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public getFilteredNotificationList(searchText) {
		return this.http.get(
			environment.apiurl +
			"/Notifications/getNotificationList?searchKey=" +
			searchText +
			"&access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public getFilteredSegmentsForNotifications(searchText) {
		return this.http.get(
			environment.apiurl +
			"/Segments/getListForNotifications?nameSearchSting=" +
			searchText +
			"&access_token=" + this.globalCfgService.getAccessToken()
		);
	}

	//search filter for segments
	public getFilteredSegmentList(searchText) {
		return this.http.get(
			environment.apiurl +
			"/Segments/getSegmentList?nameSearchSting=" +
			searchText +
			"&access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public addNotification(notification) {
		return this.http.post(
			environment.apiurl +
			"/Notifications?" + "&access_token=" +
			this.globalCfgService.getAccessToken(),
			notification
		);
	}

	public updateNotification(id, notification) {
		return this.http.patch(
			environment.apiurl +
			"/Notifications/" +
			id +
			"?access_token=" +
			this.globalCfgService.getAccessToken(),
			notification
		);
	}

	public deleteNotification(id) {
		return this.http.delete(
			environment.apiurl +
			"/Notifications/" +
			id +
			"?access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public addSegment(segment) {
		return this.http.post(
			environment.apiurl +
			"/Segments?" +
			"&access_token=" +
			this.globalCfgService.getAccessToken(),
			segment
		);
	}

	public deleteSegment(id) {
		return this.http.delete(
			environment.apiurl +
			"/Segments/" +
			id +
			"?access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public getUserList() {
		return this.http.get(
			environment.apiurl +
			"/UserLoginDetails/userKeys?" +
			"access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public getSegmentsByid(id) {
		return this.http.get(
			environment.apiurl +
			"/Segments/" +
			id +
			"?access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public postUserlistDetails(data) {
		return this.http.post(
			environment.apiurl +
			"/Segments/saveUsersToSegment" +
			"?access_token=" +
			this.globalCfgService.getAccessToken(),
			data
		);
		// console.log('userlist',this.postUserlistDetails(id,userlist));
	}

	public updateSegments(id, rec) {
		return this.http.put(
			environment.apiurl +
			"/Segments/updateSegment/" +
			id +
			"?access_token=" +
			this.globalCfgService.getAccessToken(),
			rec
		);
	}

	public getSegmentAssignedUserList(segmentId) {
		return this.http.get(
			environment.apiurl +
			"/Segments/getExistingUsersOfSegment/" +
			segmentId +
			"?access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public sendNotification(rec) {
		return this.http.post(
			environment.apiurl +
			"/Notifications/sendNotification" +
			"?access_token=" +
			this.globalCfgService.getAccessToken(),
			{ id: rec.id }
		);
	}

	public deActivateSegment(id, rec) {
		// return this.http.put(environment.apiurl + "/Segments/updateStatus/" + id + "?access_token=" + this.globalCfgService.getAccessToken());
		return this.http.put(
			environment.apiurl +
			"/Segments/updateStatus/" +
			id +
			"?access_token=" +
			this.globalCfgService.getAccessToken(),
			rec
		);
	}

	public getNotificationAssignedSegmentsList(notificationId) {
		return this.http.get(
			environment.apiurl +
			"/Notifications/segmentList?notificationId=" +
			notificationId +
			"&access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}

	public getFilteredUsersForSegments(searchText) {
		return this.http.get(
			environment.apiurl +
			"/UserLoginDetails/userKeys?nameSearchSting=" +
			searchText +
			"&access_token=" + this.globalCfgService.getAccessToken()
		);
	}

	public requestPermission() {
		if (this.globalCfgService.getLoggedInUser() !== undefined) { 
			this.angularFireMessaging.requestToken.subscribe(
				(token) => {
					if (token != null) {
						this.saveRegKey(token);
					} else {
						console.error('Unable to get token to notify.');
					}

				}, (err) => {
					console.error('Unable to get permission to notify.', err);
				}
			);
		}
	}

	getBrowserName() {
		const agent = window.navigator.userAgent.toLowerCase();

		// edge browser check
		if (agent.indexOf('edge') > -1) {
			return "edge";
		}

		// opera browser check
		if (agent.indexOf('opr') > -1 && !!(<any>window).opr) {
			return "opera";
		}

		// chrome browser check
		if (agent.indexOf('chrome') > -1 && !!(<any>window).chrome) {
			return "chrome";
		}

		// ie browser check
		if (agent.indexOf('trident') > -1) {
			return "ie";
		}

		// firefox browser check
		if (agent.indexOf('firefox') > -1) {
			return "firefox";
		}

		// safari browser check
		if (agent.indexOf('safari') > -1) {
			return "safari";
		}

		// other browsers
		return 'other';
	}

	saveRegKey(regKey) {
		let userDeviceDetail = {
			fcmKey: regKey,
			os: "",
			browser: "",
			device: "",
			deviceType: "",
			lat: null,
			lng: null
		};

		if (navigator.platform) {
			userDeviceDetail.os = navigator.platform;
		}

		// const currBrowser = this.getBrowserName();
		userDeviceDetail.browser = this.getBrowserName();

		//default value for now
		if (window.navigator.userAgent.toLowerCase().includes('mobi')) {
			userDeviceDetail.deviceType = 'mobile';
		} else {
			userDeviceDetail.deviceType = 'desktop';
		}

		// not using on browser as not treated ui friendly
		// if (navigator.geolocation) {
		// 	navigator.geolocation.getCurrentPosition((position) => {
		// 		// console.log(position);
		// 		userDeviceDetail.lat = position.coords.latitude;
		// 		userDeviceDetail.lng = position.coords.longitude;
		// 		this.saveUserKeyAndDetails(userDeviceDetail);
		// 	});
		// } else {
			this.saveUserKeyAndDetails(userDeviceDetail);
		// }
	}

	saveUserKeyAndDetails(userDeviceDetail) {
		// var rec = {
		// 	fcmKey: regKey,
		// 	platform: navigator.platform + ' ' + currBrowser
		// };
		// console.log('calling adduserkey', userDeviceDetail, userDeviceDetail.lat);
		
		this.http.post(
			environment.apiurl +
			"/UserLoginDetails/addUserKey?access_token=" +
			this.globalCfgService.getAccessToken(),
			userDeviceDetail
		).subscribe(() => { });
	}

	receiveMessage() {
		if (!this.notificationSubcription) {
			this.notificationSubcription = this.angularFireMessaging.messages.subscribe((payload) => {
				// console.log('new message received. ', payload);
				// this.currentMessage.next(payload);
				this.showCustomNotification(payload);
			});
		}
	}

	showCustomNotification(payload: any) {

		// console.log(payload);

		let title = payload.data.title;
		let options = {
			body: payload.data.body,
			// icon: payload.data.icon,
			// badge: "./assets/image/badge.png",
			// image: "./assets/image/logo.png"
		}
		// console.log('new message received: ', payload);
		if ('Notification' in window) {
			const notify = new Notification(title, options);
			notify.onclick = event => {
				event.preventDefault();
				// console.log(payload, window);
				// open in new tab to force focus and close so that focus is back on actual opened tab
				const a = window.open(payload.data.url);
				a.focus();
				a.close();
				// now load payload url after window is in focus 
				window.location.href = payload.data.url;
			}
		}
	}

	public getUserlist() {
		return this.http.get(
			environment.apiurl +
			"/UserLoginDetails?" + "&access_token=" +
			this.globalCfgService.getAccessToken()
		);
	}
}
